var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"value":_vm.divisionBet.value,"label":"Division bet","color":"green","hide-details":"auto","dark":""},on:{"change":function($event){return _vm.$emit('update:division-bet', $event !== null)}}})}
var staticRenderFns = []

export { render, staticRenderFns }